import { useCallback, useState } from 'react'

export const useModalShow = (initialShow: boolean = false) => {
  const [show, setShow] = useState(initialShow)

  const handleOpen = useCallback(() => {
    setShow(true)
  }, [])

  const handleClose = useCallback(() => {
    setShow(false)
  }, [])

  return [show, handleOpen, handleClose] as [typeof show, typeof handleOpen, typeof handleClose]
}
